<div class="p-4">
  <div class="flex justify-content-between align-items-center mb-4">
    <div class="font-semibold text-xl">Pobierz instrukcje</div>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
  </div>

  <form [formGroup]="optionsForm">
    <div class="mb-4">
      <label class="block text-sm text-color-secondary mb-2">Język instrukcji</label>
      <p-dropdown
        [appendTo]="'body'"
        formControlName="language"
        [options]="languages"
        optionLabel="name"
        optionValue="code"
        styleClass="w-full"
        class="w-full"
      ></p-dropdown>
    </div>

    <div class="mb-4" *ngIf="mode === 'bulk'">
      <label class="block text-sm text-color-secondary mb-2">Format</label>
      <p-selectButton
        formControlName="format"
        [options]="formats"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>
  </form>

  <div class="flex justify-content-end gap-3">
    <p-button label="Anuluj" [text]="true" (onClick)="cancel()" data-clarity-unmask="true"></p-button>
    <p-button label="Generuj" icon="pi pi-file-pdf" (onClick)="confirm()" data-clarity-unmask="true"></p-button>
  </div>
</div>
